import { devApiGwXAuthClient } from '../interceptor';
import { API_ENDPOINTS } from '../endpoints';
import { ChangePasswordParams } from '../../interface/settings';

export const changePassword = async (payload: ChangePasswordParams) => {
  const { data } = await devApiGwXAuthClient.post(
    API_ENDPOINTS.changePassword,
    {
      oldPassword: payload.oldPassword,
      newPassword: payload.newPassword,
      loginType: 'COR',
    },
    {
      headers: {
        'ocp-apim-subscription-key': import.meta.env.VITE_SUBSCRIPTION_KEY,
      },
    }
  );
  return data;
};
